module.exports = __webpack_public_path__ + "assets/img/intro-img.15741b53.png";